
<template>
  <div class="zmdet">
    <div class="detlist" v-if="detlist">
      <div class="detitem" v-for="(item, index) in detlist" :key="index">
        <div class="bt1">{{ item.title }}</div>
        <div class="lawdet">
          {{ item.cont | addviewall }}
          <span v-if="item.cont" @click="tojump(item)">阅读全文></span>
        </div>
      </div>
    </div>

    <div class="lawzm_detail" v-if="det">
      <div class="bt1">{{ det.tabname }}</div>
      <div class="lawdet" v-html="det.tabcontent"></div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    detlist:{
      type: Array,
      default() {
        return [];
      },
    },
    det:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {
    };
  },
  beforeMount() {
      console.log(this.detlist,'det',this.det);
  },
  methods:{
     tojump(item){
      this.$store.commit('jpcol/upzmId',item.id)
      this.$emit('changenav')
    }
  },
  filters: {
    addviewall(val) {
      if (!val) return "暂未收录相关数据！";
      else {
        return val.slice(0, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.zmdet {
  padding: 0 30px;
  .detlist {
    .detitem {
      padding: 26px 0 20px;
      border-bottom: 1px solid #eee;
      .bt1 {
        font-size: 20px;
        color: #333333;
        line-height: 20px;
      }
      .lawdet {
        margin-top: 22px;
        font-size: 14px;
        color: #999999;
        line-height: 26px;
        span {
          color: #0465ea;
          cursor: pointer;
        }
      }
    }
  }
  .lawzm_detail {
    padding: 26px 0 20px;
    .bt1 {
      font-size: 20px;
      color: #333333;
      line-height: 20px;
    }
    .lawdet {
      margin-top: 22px;
      font-size: 14px;
      color: #999999;
      line-height: 26px;
      span {
        color: #0465ea;
        cursor: pointer;
      }
    }
  }
}
</style>